<div class="cooking-container">
  <div class="cooking-header">
    <div class="title">
      <img src="assets/plans/edit-blue.svg" alt="" />

      <p>ویرایش</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-body">
    <ng-container>
      <div class="member">
        <img class="profile" [src]="getProfile(data.user)" alt="" />
        <div>
          <p>
            {{ data.user.name }}
          </p>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="delete" (click)="leave()">حذف از لیست</div>
</div>
